import { Container, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { FC, useEffect, useState } from 'react'
import { useQueryParam } from 'use-query-params'
import SearchAccordion from '../control/accordion/SearchAccordion'

import useTranslate from '../i18n/useTranslate'
import { KeywordType, useSearchSettingFaculty } from '../services/um/useSearchSettingFaculty'
import useAuthenStore from '../stores/authen/authenStore'
import Panel from './../component/um/setting-faculty/Panel'
import Result from './../component/um/setting-faculty/Result'

interface SettingFacultyProps {}
export type CertificateFormProps = {
    detailTH: string
    detailEN: string
    conditionTH: string
    conditionEN: string
}

const SettingFaculty: FC<SettingFacultyProps> = () => {
    const translate = useTranslate()
    const classes = useStyles()
    const authenStore = useAuthenStore()
    const { dataList, searchSettingFaculty } = useSearchSettingFaculty()
    const [recID, setRecID] = useQueryParam<string | null>('recID')

    const initialValues = {
        recID: recID,
        userID: authenStore.profile.userId,
    }

    useEffect(() => {
        if (authenStore.profile.userId) {
            setRecID(recID)
            searchSettingFaculty(initialValues)
        }
    }, [authenStore.profile.userId])

    const onSubmit = async (value: KeywordType) => {
        const param = {
            recID: value.recID,
            userID: authenStore.profile.userId,
        }
        value.recID && setRecID(value.recID.toString())
        setRecID(value.recID?.toString() ?? null)
        searchSettingFaculty(param)
    }

    return (
        <Container maxWidth="lg">
            <Grid className={classes.root}>
                <SearchAccordion title={translate.get('UM.SETTING_FACULTY.TITLE')}>
                    <Grid item xs={12}>
                        <Panel initialSearch={initialValues} onSubmit={onSubmit} />
                    </Grid>
                </SearchAccordion>
                <Grid item xs={12}>
                    <Result data={dataList} />
                </Grid>
            </Grid>
        </Container>
    )
}

export default SettingFaculty

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
}))
